<template>
  <div>
    <ul :class="$style.container">
      <li
        v-for="(wayToAddSystemUser, index) in addSystemUserCards"
        :key="index"
        :class="$style.cards"
      >
        <WayToAddSystemUserCard
          :wayToAddSystemUser="wayToAddSystemUser"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import WayToAddSystemUserCard from
  'client/systemusers/WaysToAddSystemUserCards/WayToAddSystemUserCard.vue';

export default {
  name: 'WaysToAddSystemUserCards',

  components: {
    WayToAddSystemUserCard,
  },

  props: {
    addSystemUserCards: {
      default: () => [],
      type: Array,
    },
  },
};
</script>

<style module>
@import './waysToAddSystemUserCards.css';
</style>
